import React, { useEffect, useState } from "react";
import Header from "../../component/Header";
import Sidebar from "../../component/SideBar";
import {
  Grid,
  Box,
  Modal,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  FormHelperText,
} from "@mui/material";
import { image } from "../../../src/common/Theme";
import { useLocation, useNavigate } from "react-router-dom";
import Apiconnection from "../../utils/Apiconnection";
import { toast } from "react-toastify";
import moment from "moment/moment";

const BookingDetails = () => {
  const [paymentMethodOptions, setPaymentMethodOptions] = useState([
    {
      value: "Cash",
      label: "Cash",
      enabled: true,
      description: "Collect payment in person",
      isQrRequired: false,
      qrCode: "",
    },
    {
      value: "Zelle",
      label: "Zelle",
      enabled: true,
      description: "Use Zelle for this checkout",
      isQrRequired: true,
      qrCode: "",
    },
    {
      value: "Cashapp",
      label: "Cashapp",
      enabled: true,
      description: "Use Cashapp for this checkout",
      isQrRequired: true,
      qrCode: "",
    },
    {
      value: "Venmo",
      label: "Venmo",
      enabled: true,
      description: "Use Venmo for this checkout",
      isQrRequired: true,
      qrCode: "",
    },
  ]);

  const getQrCodeUrl = (path) => {
    if (!path) return "";
    if (path.startsWith("http://") || path.startsWith("https://")) {
      return path;
    }
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://v2-api.primeparkusa.com";
    const cleanBaseUrl = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
    
    let cleanPath = path;
    if (!cleanPath.startsWith("uploads/payment-methods/") && !cleanPath.startsWith("/uploads/payment-methods/")) {
      if (cleanPath.startsWith("/")) {
        cleanPath = `uploads/payment-methods${cleanPath}`;
      } else {
        cleanPath = `uploads/payment-methods/${cleanPath}`;
      }
    }
    
    if (cleanPath.startsWith("/")) {
      cleanPath = cleanPath.slice(1);
    }
    
    return `${cleanBaseUrl}/${cleanPath}`;
  };

  const getPaymentList = async () => {
    try {
      const response = await Apiconnection.post("payment-method-list");
      if (response?.data?.status) {
        const list = response.data.data?.paymentMethodList || response.data.data || [];
        if (list.length > 0) {
          const mapped = list.map((item) => {
            const qrRequired = item.isQrRequired === true || item.isQrRequired === 1 || item.isQrRequired === "true";
            return {
              value: item.methodName,
              label: item.methodName,
              enabled: true,
              description: item.methodName === "Cash" ? "Collect payment in person" : `Use ${item.methodName} for this checkout`,
              isQrRequired: qrRequired,
              qrCode: item.qrCode,
              id: item.paymentMethodId || item.id,
            };
          });
          setPaymentMethodOptions(mapped);
        }
      }
    } catch (error) {
      console.error("Error fetching payment list:", error);
    }
  };

  useEffect(() => {
    getPaymentList();
  }, []);

  const location = useLocation();
  const navigate = useNavigate();
  const { bookingDetails, payload } = location.state || {};

  const [customerName] = useState(
    `${payload?.firstName || ""} ${payload?.lastName || ""}`.trim(),
  );
  const [Firstname] = useState(payload?.firstName);
  const [Lastname] = useState(payload?.lastName);
  const [vendorId] = useState(payload?.vendorId);
  const [email] = useState(payload?.email);
  const [vechiletypeId] = useState(payload?.vehicleTypeId);
  const [ReservationId] = useState(payload?.reservationId);
  const [cnfReservationId] = useState(payload?.reservationId);
  const [bookingPlatform] = useState(payload?.bookingPlatform);
  const [logInType] = useState(payload?.logInType);
  const [slotId] = useState(payload?.slotId);
  const [dialCode] = useState(payload?.dialCode);
  const [fromDate] = useState(payload?.fromDate);
  const [toDate] = useState(payload?.toDate);
  const [actualvehicleTypeId] = useState(payload?.actualvehicleTypeId);
  const [onSiteChargeForVendor] = useState(payload?.onSiteChargeForVendor);
  const [mobileNumber] = useState(payload?.phone);
  const [plateNumber] = useState(payload?.plateNumber);
  const [confirmPlateNumber] = useState(payload?.plateNumber);
  const [numPassengers, setNumPassengers] = useState(payload?.passengerCount);
  const [carType, setCarType] = useState(payload?.carType || "");
  const [slotName, setSlotName] = useState(payload?.slotName || "");
  const [startDateTime, setStartDateTime] = useState(payload?.fromDate);
  const [endDateTime, setEndDateTime] = useState(payload?.toDate);
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [invoiceCreate, setInvoiceCreate] = useState({});
  const [bookings, setBookings] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentMethodError, setPaymentMethodError] = useState("");
  const [openCheckoutModal, setOpenCheckoutModal] = useState(false);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const handlePaymentMethodChange = (event) => {
    setPaymentMethod(event.target.value);
    setPaymentMethodError("");
  };

  const formatCurrency = (value) => `$${Number(value || 0).toFixed(0)}`;
  const formatDateTime = (date, time) => {
    if (!date) return "--";
    const input = time ? `${date} ${time}` : date;
    const parsed = moment(input, ["YYYY-MM-DD HH:mm", moment.ISO_8601], true);
    return parsed.isValid() ? parsed.format("ddd, DD MMM • hh:mm A") : "--";
  };

  const checkInLabel = formatDateTime(
    payload?.fromDate,
    payload?.selectedCheckInTime,
  );
  const checkOutLabel = formatDateTime(
    payload?.toDate,
    payload?.selectedCheckOutTime,
  );
  const isBookedStatus = bookingDetails?.bookingStatus === "Booked";

  const actulfromDate = new Date(startDateTime);
  const actultoDate = new Date(endDateTime);
  actulfromDate.setHours(0, 0, 0, 0);
  actultoDate.setHours(0, 0, 0, 0);

  const calculateDays =
    Math.ceil((actultoDate - actulfromDate) / (1000 * 60 * 60 * 24)) + 1;
  const onlineBookingAmount = Number(invoiceCreate?.onlineBookingAmount || 0);
  const reservationAmount = Number(invoiceCreate?.reservationAmount || 0);
  const onSiteVendorCharge = Number(invoiceCreate?.onSiteChargeForVendor || 0);
  const payableAmount = Number(invoiceCreate?.payableAmount || 0);
  const dueAmount = Number(invoiceCreate?.dueAmount || 0);
  const amountPaidDuringBooking = onlineBookingAmount + reservationAmount;
  const parkingChargeDisplay = isBookedStatus
    ? calculateDays *
      ((payload?.oversizeRate || 0) + (payload?.dailyParkingRate || 0))
    : Number(invoiceCreate?.parkingChargeTotal || 0);

  const summaryRows = [
    { label: "Customer", value: customerName || "--" },
    { label: "Vehicle Plate", value: plateNumber || "--" },
    { label: "Check-in", value: checkInLabel },
    { label: "Check-out", value: checkOutLabel },
    {
      label: "Booking status",
      value: bookingDetails?.bookingStatus || "Pending",
    },
  ];

  const costRows = [
    {
      label: "Online Booking Charges",
      value: formatCurrency(onlineBookingAmount),
    },
    { label: "Oversized Charges", value: formatCurrency(parkingChargeDisplay) },
    { label: "Reservation Charges", value: formatCurrency(reservationAmount) },
    {
      label: "On-Site Vendor Charge",
      value: formatCurrency(onSiteVendorCharge),
    },
    {
      label: "Amount paid during booking",
      value: formatCurrency(amountPaidDuringBooking),
    },
    { label: "Amount to pay now", value: formatCurrency(dueAmount) },
  ];

  const breakdownRows = [
    {
      label: "Early Check-In Fee",
      meta: null,
      value: formatCurrency(invoiceCreate?.earlyCheckinAmountTotal),
    },
    {
      label: "Overstay Charges",
      meta: `${invoiceCreate?.overstayDays || 0} days`,
      value: formatCurrency(invoiceCreate?.overstayAmountTotal),
    },
    {
      label: "Extra Passenger Fees",
      meta: `${invoiceCreate?.extraPassengers || 0} passengers`,
      value: formatCurrency(invoiceCreate?.extraPassengerChargesTotal),
    },
    {
      label: "Parking Rate",
      meta: `${calculateDays} days - ${carType || "Vehicle"}`,
      value: formatCurrency(parkingChargeDisplay),
    },
  ];

  const bookingHighlights = [
    { label: "Customer mobile", value: mobileNumber || "--" },
    { label: "Reservation ID", value: payload?.reservationId || "--" },
    { label: "Plate number", value: plateNumber || "--" },
    { label: "Car type", value: carType || "--" },
    { label: "Passenger count", value: payload?.passengerCount || 0 },
    { label: "Check-in window", value: checkInLabel },
    { label: "Check-out window", value: checkOutLabel },
    { label: "Slot number", value: slotName || "--" },
  ];

  const handleOpenCheckoutModal = () => {
    setOpenCheckoutModal(true);
  };

  const handleCloseCheckoutModal = () => {
    setOpenCheckoutModal(false);
    setPaymentMethodError("");
  };

  const handleCheckInFormSubmit = async () => {
    try {
      const currentDateTime = moment().format("YYYY-MM-DD HH:mm");
      const requestPayload = {
        bookingRequestId: bookingDetails?.id,
        actualvehicleTypeId,
        actualFromDate: moment(currentDateTime).format("YYYY-MM-DD"),
        actualCheckInTime: moment(currentDateTime).format("HH:mm"),
        slotId,
        plateNumber,
        passengerCount: numPassengers,
        onSiteChargeForVendor,
        paymentMethod,
      };

      const response = await Apiconnection.post(
        "mark-check-in",
        requestPayload,
      );
      if (response.data.status) {
        const updatedBookings = bookings.map((booking) =>
          booking.id === requestPayload.bookingRequestId
            ? { ...booking, bookingStatus: "Checked In" }
            : booking,
        );
        setBookings(updatedBookings);
        toast.success("Check-in successful!");

        const calculateChargesPayload = {
          bookingRequestId: response.data.data.updatedBookingRequest.id,
          vehicleTypeId:
            response.data.data.updatedCarMovement.actualvehicleTypeId,
          passengerCount: numPassengers,
          checkinDate: response.data.data.updatedCarMovement.actualFromDate,
          startTime: response.data.data.updatedCarMovement.actualCheckInTime,
          checkoutDate: response.data.data.updatedBookingRequest.toDate,
          endTime:
            response.data.data.updatedBookingRequest.selectedCheckOutTime,
          platformMedium:
            response.data.data.updatedBookingRequest?.transactionHistoryId ===
            ""
              ? "AdminBooking"
              : "",
        };

        const calculateChargesResponse = await Apiconnection.post(
          "calculate-booking-charges-after-check-in",
          calculateChargesPayload,
        );
        if (!calculateChargesResponse.data.status) {
          toast.error(calculateChargesResponse.data.message);
        }

        // Confirm payment via the dedicated endpoint (after invoice is created)
        const confirmPaymentResponse = await Apiconnection.post(
          "confirm-booking-payment",
          {
            bookingRequestId: bookingDetails?.id,
            paymentMethod,
            action: "CONFIRM",
          },
        );
        if (!confirmPaymentResponse?.data?.status) {
          toast.error(
            confirmPaymentResponse?.data?.message ||
              "Payment confirmation failed!",
          );
          return;
        }

        navigate("/booking-receipts", {
          state: {
            id: bookingDetails?.id,
            tid: response.data.data?.updatedBookingRequest?.transactionHistoryId || null,
          },
        });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating check-in:", error);
      toast.error("Failed to update check-in.");
    }
  };

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();
    }

    try {
      if (!paymentMethod) {
        setPaymentMethodError("Please select a payment method.");
        toast.error("Please select a payment method.");
        return;
      }

      if (isBookedStatus) {
        await handleCheckInFormSubmit();
        return;
      }

      const bookingPayload = {
        bookingPlatform: "adminPanel",
        logInType: payload.customerExist ? "Customer" : "Guest",
        slotId: payload.slotId,
        slotName,
        firstName: payload.firstName,
        lastName: payload.lastName,
        vehicleTypeId: payload.vehicleTypeId,
        email: payload.email,
        dialCode: payload.dialCode,
        phone: payload.phone,
        plateNumber: payload.plateNumber,
        fromDate: moment(startDateTime).format("YYYY-MM-DD"),
        selectedCheckInTime: moment(startDateTime).format("HH:mm"),
        toDate: moment(endDateTime).format("YYYY-MM-DD"),
        selectedCheckOutTime: moment(endDateTime).format("HH:mm"),
        passengerCount: numPassengers,
        customerId: payload.customerId,
        vendorId: payload.vendorId,
        actualvehicleTypeId: payload.vehicleTypeId,
        actualFromDate: moment(startDateTime).format("YYYY-MM-DD"),
        actualCheckInTime: moment(startDateTime).format("HH:mm"),
        actualToDate: moment(endDateTime).format("YYYY-MM-DD"),
        actualCheckOutTime: moment(endDateTime).format("HH:mm"),
        carType: payload.carType,
        dailyParkingRate: payload.dailyParkingRate,
        reservationId: payload.reservationId,
        onSiteChargeForVendor: Number(payload.onSiteChargeForVendor),
        platformMedium: isBookedStatus ? "" : "AdminBooking",
        paymentMethod,
      };

      const bookingResponse = await Apiconnection.post(
        "booking-request-create",
        bookingPayload,
      );
      if (!bookingResponse?.data?.status) {
        toast.error("Failed to create booking!");
        return;
      }

      const bookingRequestId = bookingResponse.data.data.id;

      const calculateBookingChargesPayload = {
        platformMedium: "AdminBooking",
        platform: "AdminPanel",
        bookingRequestId,
        vendorId: payload.vendorId,
        onSiteChargeForVendor: payload.onSiteChargeForVendor,
        vehicleTypeId: payload.vehicleTypeId,
        passengerCount: numPassengers,
        checkinDate: moment(startDateTime).format("YYYY-MM-DD"),
        startTime: moment(startDateTime).format("HH:mm"),
        checkoutDate: moment(endDateTime).format("YYYY-MM-DD"),
        endTime: moment(endDateTime).format("HH:mm"),
        reservationId: payload.reservationId,
        paymentMethod,
      };

      const calculateBookingChargesResponse = await Apiconnection.post(
        "calculate-booking-charges-before-booking",
        calculateBookingChargesPayload,
      );
      if (!calculateBookingChargesResponse?.data?.status) {
        toast.error("Failed to calculate booking charges!");
        return;
      }

      // Confirm payment via the dedicated endpoint (after invoice is created)
      const confirmPaymentResponse = await Apiconnection.post(
        "confirm-booking-payment",
        {
          bookingRequestId,
          paymentMethod,
          action: "CONFIRM",
        },
      );
      if (!confirmPaymentResponse?.data?.status) {
        toast.error(
          confirmPaymentResponse?.data?.message ||
            "Payment confirmation failed!",
        );
        return;
      }

      toast.success("Booking created successfully!");
      handleCloseCheckoutModal();
      navigate("/booking-receipts", {
        state: {
          id: bookingRequestId,
          tid: bookingResponse.data.data?.transactionHistoryId || null,
        },
      });
    } catch (error) {
      console.error("Error during booking process:", error);
      toast.error(
        error.response?.data?.message || "Failed to process booking!",
      );
    }
  };

  useEffect(() => {
    const bookingRequestId = location.state?.bookingRequestId;
    if (bookingRequestId) {
      getBookingDetails(bookingRequestId);
    }
  }, [location.state]);

  useEffect(() => {
    const getPreBookingChargeSummary = async () => {
      if (!payload) {
        console.error(
          "Error fetching pre-booking charge summary: Payload is null or undefined",
        );
        return;
      }

      try {
        const currentDateTime = moment();
        const startTime = isBookedStatus
          ? currentDateTime.format("HH:mm")
          : payload.selectedCheckInTime;

        const payloadData = {
          platform: "AdminPanel",
          vendorId: Number(payload.vendorId),
          onSiteChargeForVendor: Number(payload.onSiteChargeForVendor),
          vehicleTypeId: payload.vehicleTypeId,
          passengerCount: payload.passengerCount,
          checkinDate: payload.fromDate,
          startTime,
          checkoutDate: payload.toDate,
          endTime: payload.selectedCheckOutTime,
          reservationId: payload.reservationId,
          platformMedium: isBookedStatus ? "" : "AdminBooking",
        };

        const response = await Apiconnection.post(
          "pre-booking-charge-summary",
          payloadData,
        );
        if (response?.data?.status) {
          setInvoiceCreate(response.data.data.bookingChargesSummary);
          setNumPassengers(payload.passengerCount);
          setCarType(payload.carType);
          setSlotName(payload.slotName || "");
          setStartDateTime(
            `${payload.fromDate}T${payload.selectedCheckInTime}`,
          );
          setEndDateTime(`${payload.toDate}T${payload.selectedCheckOutTime}`);
        } else {
          console.error(
            "Error fetching pre-booking charge summary:",
            response?.data?.message,
          );
        }
      } catch (error) {
        console.error("Error fetching pre-booking charge summary:", error);
      }
    };

    getPreBookingChargeSummary();
  }, [payload, isBookedStatus]);

  const getBookingDetails = async (bookingRequestId) => {
    try {
      const response = await Apiconnection.post(
        "calculate-booking-charges-before-booking",
        {
          bookingRequestId,
        },
      );
      if (response?.data?.status) {
        setInvoiceCreate(response.data.data.invoiceCreate);
      } else {
        console.error("Error fetching booking details:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching booking details:", error);
    }
  };

  return (
    <>
      <div className="grid-container">
        <Header OpenSidebar={OpenSidebar} />
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <div className="inner-container">
          <div className="booking-details-sec booking-redesign">
            <div className="booking-redesign-hero">
              <div>
                <span className="booking-redesign-eyebrow">
                  Booking checkout
                </span>
                <h2>
                  Review details, verify charges, and complete payment in one
                  flow.
                </h2>
              </div>
              <div className="booking-redesign-due-card">
                <span>Due now</span>
                <strong>{formatCurrency(dueAmount)}</strong>
                <small>
                  {isBookedStatus
                    ? "Required to finish check-in"
                    : "Ready for checkout confirmation"}
                </small>
              </div>
            </div>

            <Grid container spacing={3}>
              <Grid item lg={7} md={7} xs={12}>
                <div className="details-box booking-redesign-card">
                  <div className="booking-card-head">
                    <div>
                      <span className="booking-card-kicker">
                        Booking overview
                      </span>
                      <h5>Customer and reservation details</h5>
                    </div>
                    <span
                      className={`booking-status-pill ${isBookedStatus ? "checked-in" : "pending"}`}
                    >
                      {bookingDetails?.bookingStatus || "Pending"}
                    </span>
                  </div>

                  <div className="booking-detail-grid">
                    {bookingHighlights.map((item) => (
                      <div key={item.label} className="booking-detail-item">
                        <span>{item.label}</span>
                        <strong>{item.value}</strong>
                      </div>
                    ))}
                  </div>

                  <div className="booking-payment-callout">
                    <div>
                      <span className="booking-card-kicker">Payment step</span>
                      <h6>
                        Payment method will be selected in a secure checkout
                        modal.
                      </h6>
                      <p>
                        Click submit to review the final summary and confirm the
                        payment method before we finish the booking.
                      </p>
                    </div>
                    <Button
                      className="edit-btn"
                      onClick={() => {
                        const updatedPayload = {
                          vendorId,
                          email,
                          customerName,
                          firstName: Firstname,
                          lastName: Lastname,
                          mobileNumber,
                          plateNumber,
                          confirmPlateNumber,
                          carType,
                          reservationId: ReservationId,
                          cnfReservationId,
                          vechiletypeId,
                          startDateTime,
                          endDateTime,
                          numPassengers,
                          slotName,
                          bookingPlatform,
                          logInType,
                          slotId,
                          dialCode,
                          fromDate,
                          toDate,
                          onSiteChargeForVendor,
                        };
                        navigate("/add-booking", { state: { updatedPayload } });
                      }}
                      disabled={isBookedStatus}
                    >
                      <img src={image.edit} alt="edit" />
                      Edit booking
                    </Button>
                  </div>
                </div>
              </Grid>

              <Grid item lg={5} md={5} xs={12}>
                <div className="billing-details booking-redesign-card booking-pricing-card">
                  <div className="booking-card-head compact">
                    <div>
                      <span className="booking-card-kicker">
                        Amount summary
                      </span>
                      <h5>What the customer is paying</h5>
                    </div>
                    <div className="booking-pricing-badge">
                      <span>Charge today</span>
                      <strong>{formatCurrency(dueAmount)}</strong>
                    </div>
                  </div>

                  <div className="booking-pricing-rows">
                    {costRows.map((item) => (
                      <div
                        key={item.label}
                        className={`billing-box booking-pricing-row ${item.label === "Amount to pay now" ? "highlighted" : ""}`}
                      >
                        <p>{item.label}</p>
                        <h6>{item.value}</h6>
                      </div>
                    ))}
                  </div>

                  <div className="price-breakup booking-breakdown-card">
                    <div className="booking-breakdown-head">
                      <span className="booking-card-kicker">
                        Detailed breakdown
                      </span>
                      <p>Charges that shape the final parking total.</p>
                    </div>
                    {breakdownRows.map((item) => (
                      <div
                        key={item.label}
                        className="billing-box booking-breakdown-row"
                      >
                        <p>
                          {item.label}
                          {item.meta ? <span>({item.meta})</span> : null}
                        </p>
                        <h6>{item.value}</h6>
                      </div>
                    ))}
                  </div>

                  <div className="booking-payment-footer-card">
                    <div className="booking-total-strip">
                      <div className="booking-total-block emphasis single-total">
                        <span>Total due amount</span>
                        <strong>{formatCurrency(dueAmount)}</strong>
                      </div>
                    </div>

                    <Box className="booking-pricing-actions">
                      <Button
                        type="button"
                        className="save-btn booking-checkout-btn"
                        onClick={handleOpenCheckoutModal}
                      >
                        Submit
                      </Button>
                    </Box>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>

      <Modal open={openCheckoutModal} onClose={handleCloseCheckoutModal}>
        <Box className="booking-checkout-modal">
          <button
            type="button"
            className="booking-modal-close"
            onClick={handleCloseCheckoutModal}
          >
            x
          </button>

          <div className="booking-checkout-layout">
            <div className="booking-checkout-summary">
              <h3>Booking Summary</h3>
              <div className="booking-checkout-summary-list">
                {summaryRows.map((item) => (
                  <div
                    key={item.label}
                    className="booking-checkout-summary-row"
                  >
                    <span>{item.label}</span>
                    <strong>{item.value}</strong>
                  </div>
                ))}
              </div>

              <div className="booking-checkout-summary-list booking-cost-summary">
                {costRows.map((item) => (
                  <div
                    key={item.label}
                    className="booking-checkout-summary-row"
                  >
                    <span>{item.label}</span>
                    <strong>{item.value}</strong>
                  </div>
                ))}
              </div>
            </div>

            <div className="booking-checkout-payment">
              <div className="booking-checkout-head">
                <h3>Secure Checkout</h3>
                <p>Choose how you want to collect payment for this booking.</p>
              </div>

              <FormControl
                error={Boolean(paymentMethodError)}
                className="booking-payment-methods"
              >
                <FormLabel id="payment-method-label">Payment methods</FormLabel>
                <RadioGroup
                  aria-labelledby="payment-method-label"
                  name="payment-method"
                  value={paymentMethod}
                  onChange={handlePaymentMethodChange}
                >
                  {paymentMethodOptions.map((method) => (
                    <FormControlLabel
                      key={method.value}
                      value={method.value}
                      className="booking-payment-method-option"
                      control={<Radio />}
                      disabled={!method.enabled}
                      label={
                        <div className="booking-payment-option-label-container">
                          <div className="booking-payment-option-copy">
                            <strong>{method.label}</strong>
                            <span>
                              {method.description}
                            </span>
                          </div>
                          {method.isQrRequired && method.qrCode && paymentMethod === method.value && (
                            <div className="booking-payment-qr-container">
                              <img
                                src={getQrCodeUrl(method.qrCode)}
                                alt={`${method.label} QR Code`}
                                className="booking-payment-qr-image"
                              />
                            </div>
                          )}
                        </div>
                      }
                    />
                  ))}
                </RadioGroup>
                {paymentMethodError ? (
                  <FormHelperText>{paymentMethodError}</FormHelperText>
                ) : null}
              </FormControl>

              <div className="booking-checkout-footer">
                <Button
                  type="button"
                  className="cancel-btn booking-modal-cancel"
                  onClick={handleCloseCheckoutModal}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  className="save-btn booking-modal-confirm"
                  onClick={handleSubmit}
                >
                  Confirm Payment
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default BookingDetails;
